import React, { Component } from 'react'
import { render } from 'react-dom'

import { InlineMath, BlockMath } from 'react-katex';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark, darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

class Chapter300 extends Component {
  render() {
    return (
      <div className="base">

        <Header as='h1'>
        3. Ehrenberg 論文紹介
        </Header>

本章では以下の論文について解説を行います。随時追加していく予定です。<br/>

<ol>
  <li><a href="https://www.empgens.com/article/repeat-buying/" target="_blank">Repeat-Buying</a></li>
</ol>

      </div>
    )   
  }
}

export default Chapter300;
